<template>
  <div ref="box" id="app" class="baseContainer" @scroll="scrollEvent">
    <div v-if="false" class="screen-width">{{ screenWidth }}</div>
    <router-view />
  </div>
</template>

<script>
import {getItem, setItem} from "@/utils/storage";

export default {
  name: 'App',
  data () {
    return {
      screenWidth: 0
    }
  },
  mounted () {
    // 刷新页面前存储vuex的数据
    window.addEventListener("beforeunload", () => {
      setItem("stateInfo", this.$store.state);
    });
    if (getItem("stateInfo")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          getItem("stateInfo")
        )
      );
    }
  },

  methods: {
    /**
     * 监听页面的宽度变化
     */
    resizeEventListener () {
      this.screenWidth = document.body.offsetWidth;
      window.addEventListener('resize', () => {
        this.screenWidth = document.body.offsetWidth;
        this.$store.commit('common/setScreenWidth', this.screenWidth)
      })
    },
    /**
     * todo 获取距离顶部的距离
     */
    scrollEvent () {
      this.$store.commit(
        'common/setScrollTop',
        document.documentElement.scrollTop
      )
    },
    /**
     * todo 刷新token
     */
    refreshToken () {
      setTimeout(() => {
        const nowTime = new Date().getTime()
        if (getItem('TOKEN_TIME')) {
          let tokenTime = getItem('TOKEN_TIME') || 0
          if (nowTime - tokenTime >= 1000 * 60 * 20) {
            this.$store.dispatch('useModule/refreshGeelyToken')
            setItem('TOKEN_TIME', new Date().getTime())
          }
        }
        this.refreshToken()
      }, 1000 * 60)
    }
  }
}
</script>

<style>
:root {
  --centerWidth: 1100px; /*版心的宽度*/
  --leftWidth: 750px; /*左边视图的宽度*/
  --rightWidth: 330px; /*右边视图的宽度*/
  --dialogWidth: 749px; /*弹框的宽度*/

  --fontSize1: 16px; /*标题字号*/
  --fontSize2: 14px; /*正文字号*/
  --fontSize3: 12px; /*最小字号*/

  --color1: #215add;
  --color2: #ff7a00;
  --color3: #ff0a0a;
  --color4: #8590a6;

  --lineColor: #f0f3f5; /*分割线颜色*/

  --fontColor1: #292929; /*主要字体色*/
  --fontColor2: #808080; /*次要字体色*/
  --fontColor3: #999999; /*次要字体色*/
  --fontColor4: #000000; /*次要字体色*/

  --backgroundColor1: #f8f8f8
}

#app {
  color: var(--fontColor1);
  font: 14px/1.4 'myFont', 'PingFang SC';
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.screen-width {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
  color: #FFFFFF;
}

.appLayout {
  min-width: 1200px !important;
}
</style>
